import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const ExportIcon = forwardRef<SVGSVGElement, IconProps>(function ExportIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16138 4.1477C8.18215 3.90613 8.39454 3.72716 8.63576 3.74796C9.75332 3.84434 10.6286 4.1885 11.2094 4.90533C11.7804 5.61004 12 6.59492 12 7.82049V7.89659C12 9.2483 11.7324 10.3088 11.0219 11.0204C10.3113 11.732 9.25232 12 7.90258 12H4.09742C2.74768 12 1.68868 11.732 0.978131 11.0204C0.267582 10.3088 0 9.2483 0 7.89659V7.82049C0 6.60382 0.216682 5.62487 0.778479 4.9216C1.35041 4.20563 2.21292 3.85692 3.3144 3.75409C3.55547 3.73159 3.76911 3.90905 3.79158 4.15047C3.81405 4.39189 3.63685 4.60584 3.39578 4.62835C2.4281 4.71869 1.83225 5.00803 1.46312 5.47011C1.08385 5.94488 0.876766 6.68398 0.876766 7.82049V7.89659C0.876766 9.16146 1.13232 9.9331 1.5981 10.3996C2.06388 10.866 2.83439 11.122 4.09742 11.122H7.90258C9.16561 11.122 9.93612 10.866 10.4019 10.3996C10.8677 9.9331 11.1232 9.16146 11.1232 7.89659V7.82049C11.1232 6.67532 10.9133 5.93337 10.5286 5.45857C10.1537 4.99589 9.54722 4.70786 8.56054 4.62277C8.31932 4.60197 8.14061 4.38927 8.16138 4.1477Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00292 0.655678C6.24504 0.655678 6.44131 0.852236 6.44131 1.0947V7.75617C6.44131 7.99863 6.24504 8.19519 6.00292 8.19519C5.76081 8.19519 5.56454 7.99863 5.56454 7.75617V1.0947C5.56454 0.852236 5.76081 0.655678 6.00292 0.655678Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.69294 0.128587C5.86414 -0.0428624 6.14171 -0.0428624 6.31291 0.128587L8.27102 2.08956C8.44222 2.26101 8.44222 2.53899 8.27102 2.71044C8.09982 2.88189 7.82225 2.88189 7.65105 2.71044L6.00292 1.0599L4.3548 2.71044C4.1836 2.88189 3.90603 2.88189 3.73483 2.71044C3.56363 2.53899 3.56363 2.26101 3.73483 2.08956L5.69294 0.128587Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
